import React from "react";

const SignUpIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg viewBox="0 0 66 66" fill="none" {...props}>
    <g filter="url(#filter0_d_10457_1714)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20.687C10 14.443 14.436 10 20.669 10h24.384c6.234 0 10.67 4.443 10.67 10.687v25.188c0 5.48-4.437 9.923-9.908 9.923H19.907c-5.472 0-9.907-4.443-9.907-9.923V20.687z"
        fill="url(#paint0_linear_10457_1714)"
      />
    </g>
    <path
      d="M20.125 42.125c4.583-2.75 6.875-5.5 6.875-8.25 0-4.125-1.375-4.125-2.75-4.125s-2.794 1.492-2.75 4.125c.047 2.816 2.28 3.956 3.438 5.5 2.062 2.75 3.437 3.438 4.812 1.375.917-1.375 1.605-2.52 2.063-3.438 1.375 3.208 3.207 4.813 5.5 4.813h3.437m0 0L38 39.375v-16.5a2.722 2.722 0 012.75-2.75 2.722 2.722 0 012.75 2.75v16.5l-2.75 2.75zM38 25.625h5.5"
      stroke="#8065C9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_10457_1714"
        x={0}
        y={0}
        width={65.7227}
        height={65.7979}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10457_1714"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_10457_1714"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10457_1714"
        x1={10}
        y1={10}
        x2={10}
        y2={55.798}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#E8E8E8" />
      </linearGradient>
    </defs>
  </svg>
);

export default SignUpIcon;
